import * as yup from 'yup';
import { matchIsValidTel } from 'mui-tel-input';
import { IntlShape } from 'react-intl';

const validatePhoneNumber = (phoneNumber = '') => {
  if (!phoneNumber) return true;
  return matchIsValidTel(phoneNumber);
};

export const createProfileFormSchema = (intl: IntlShape) => {
  const requiredField = intl.formatMessage({
    id: 'customer-platform.shared.components.forms.errors.required',
  });

  const phoneNumberValidationError = intl.formatMessage({
    id: 'customer-platform.shared.components.forms.errors.phone_number.invalid',
  });

  return yup.object().shape({
    user: yup.object().shape({
      firstName: yup.string().required(requiredField),
      lastName: yup.string().required(requiredField),
      phoneNumber: yup
        .string()
        .test(
          'phoneNumberValidation',
          phoneNumberValidationError,
          validatePhoneNumber,
        )
        .required(requiredField),
      whatsappPhoneNumber: yup
        .string()
        .test(
          'phoneNumberValidation',
          phoneNumberValidationError,
          validatePhoneNumber,
        )
        .when('whatsappConsent', {
          is: true,
          then: schema => schema.required(requiredField),
          otherwise: schema => schema.optional(),
        }),
      whatsappConsent: yup.boolean().required(),
    }),
    company: yup.object().shape({
      address: yup.string().optional(),
      postalCode: yup
        .string()
        .nullable()
        .optional()
        .transform(value => (value === '' ? null : value)),
    }),
  });
};
